import { render, staticRenderFns } from "./DownloadsDash.vue?vue&type=template&id=bf5a7d46&"
import script from "./DownloadsDash.vue?vue&type=script&lang=js&"
export * from "./DownloadsDash.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports